module.exports = __webpack_public_path__ + "img/18.cf166879.jpg";